import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setup-container ready" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Ready to go!", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, "Let's create your first meeting type.", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("aside", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Example:"),
  /*#__PURE__*/_createElementVNode("p", null, "Initial Consultation Meeting "),
  /*#__PURE__*/_createElementVNode("p", null, "$50 for 30 minutes"),
  /*#__PURE__*/_createElementVNode("p", null, "Location: Video Call")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "button-container-setup-ready flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        class: "link help-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showVideo=true))
      }, "What is a meeting type?"),
      _createElementVNode("button", {
        class: "outline send-invite",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goTo('/new-invite')))
      }, "Next")
    ]),
    ($setup.showVideo)
      ? (_openBlock(), _createBlock($setup["PopupVideo"], {
          key: 0,
          videoLink: "meetingType",
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.showVideo = false))
        }))
      : _createCommentVNode("v-if", true)
  ]))
}